import { councilConsumptionApi } from "@/lib/api"
import type { ApiResponseWaterConsumptionDTO, WaterConsumptionDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetWaterConsumption = (councilId: string, userId: string) => {
  return useQuery({
    queryKey: [useGetWaterConsumption.QUERY_KEY, councilId, userId],
    queryFn: async () => {
      try {
        const response = await councilConsumptionApi.getWaterConsumption(councilId, Number(userId))
        return (response.data as ApiResponseWaterConsumptionDTO).data as WaterConsumptionDTO
      } catch {
        return undefined
      }
    },
    enabled: !!councilId && !!userId,
    retry: false,
    throwOnError: false,
  })
}

useGetWaterConsumption.QUERY_KEY = "water-consumption"

export default useGetWaterConsumption
